<!-- =========================================================================================
  File Name: FullPage.vue
  Description: Full page layout
  ----------------------------------------------------------------------------------------
  Item Name: GCI 2020
  Author: Dtsmart
  Author URL: http://dtsmart.vn
========================================================================================== -->


<template>
  <div class="layout--full-page">
    <router-view></router-view>
    <NoLongerUpdateAlert />
  </div>
</template>

<script>
import NoLongerUpdateAlert from "@/layouts/components/NoLongerUpdateAlert.vue";

export default {
  components: {
    NoLongerUpdateAlert
  }
}
</script>